/*
 * Mantún · Escalera de descuentos (copiado de FunFungi el 17-10-2026) con lo que ya hay en el carrito (17-10-2026, pedido de Mau).
 * Fuente única: metacampo de la tienda mantun.escalera (JSON), que snippets/mt-tienda.liquid imprime en
 * <script id="mt-escalera-datos">. De ahí salen también los descuentos automáticos de Shopify: si se cambia un
 * escalón, se cambia el metacampo y se vuelven a crear los descuentos con el mismo dato.
 *
 * Familias: «monto» (extractos: el escalón depende del total de lista de la familia en el carrito) o «cantidad»
 * (café y té: depende de las unidades). Los regalos en $0 no cuentan (Shopify tampoco los cuenta).
 *
 * API (window.MTEscalera):
 *   cotizar(productId, listaUnidad, cantidad) → { pct, pctAntes, total, lista, unidad, extra, ahorroCarrito }
 *     total = lo que cuestan esas unidades con el escalón que alcanza el carrito al sumarlas;
 *     extra = cuánto sube el total del carrito (incluye que lo que ya estaba también baja de escalón).
 *   familia(productId) · carrito() · alCambiar(fn) · actualizar() · minimosRegalos(productId, lista, regalos) · idDeHandle(handle)
 *   (también avisa con el evento «mt-escalera:carrito» cada vez que lee el carrito)
 * Además ajusta sola la escalera de Shrine en la ficha (quantity-breaks) cuando el carrito ya tiene
 * productos de la misma familia, y pone una nota arriba; y el precio de las tarjetas (.mt-precio-dinamico,
 * snippets/card-product.liquid) con «X % OFF con tu carrito», y los precios sueltos (.mt-precio-simple: botón del
 * final de los artículos, videos comprables) y las sugerencias del carrito de Kaching (.mte-up).
 */
(function () {
  'use strict';
  if (window.MTEscalera) return;
  var nodo = document.getElementById('mt-escalera-datos');
  var datos = null;
  try { datos = JSON.parse(nodo && nodo.textContent || 'null'); } catch (e) { datos = null; }
  if (!datos || !datos.familias) return;

  var famDe = {};
  datos.familias.forEach(function (f) { f.productos.forEach(function (id) { famDe[String(id)] = f; }); });

  var carrito = null, oyentes = [];
  function plata(n) { return '$' + Math.round(n).toLocaleString('es-CL'); }
  function pctPara(f, medida) {
    var p = 0;
    f.escalones.forEach(function (e) { if (medida >= e.desde && e.pct > p) p = e.pct; });
    return p;
  }
  // Medida de la familia en el carrito (monto de lista o unidades) y su total de lista, sin regalos en $0.
  function enCarrito(f) {
    var medida = 0, lista = 0;
    ((carrito && carrito.items) || []).forEach(function (it) {
      if (famDe[String(it.product_id)] !== f) return;
      if (it.final_line_price === 0) return;
      var unidad = (it.original_price || it.price) / 100;
      lista += unidad * it.quantity;
      medida += f.tipo === 'monto' ? unidad * it.quantity : it.quantity;
    });
    return { medida: medida, lista: lista };
  }
  function cotizar(productId, listaUnidad, cantidad) {
    var f = famDe[String(productId)];
    cantidad = cantidad || 1;
    var lista = listaUnidad * cantidad;
    if (!f) return { pct: 0, pctAntes: 0, total: lista, lista: lista, unidad: listaUnidad, extra: lista, ahorroCarrito: 0, familia: null };
    var ya = enCarrito(f);
    var suma = f.tipo === 'monto' ? listaUnidad * cantidad : cantidad;
    var pctAntes = pctPara(f, ya.medida);
    var pct = pctPara(f, ya.medida + suma);
    var total = Math.round(lista * (1 - pct / 100));
    var antes = Math.round(ya.lista * (1 - pctAntes / 100));
    var despues = Math.round(ya.lista * (1 - pct / 100)) + total;
    return {
      pct: pct, pctAntes: pctAntes, total: total, lista: lista, unidad: Math.round(listaUnidad * (1 - pct / 100)),
      extra: despues - antes, ahorroCarrito: Math.max(0, antes - Math.round(ya.lista * (1 - pct / 100))),
      familia: f, yaEnCarrito: ya.medida > 0
    };
  }

  // Varios productos a la vez (p. ej. «Agrégalos a tu carrito»): items = [{ id, lista, cantidad }].
  // Devuelve el total de cada uno y del conjunto con el escalón que alcanzan juntos más lo que ya hay en el carrito.
  function cotizarVarios(items) {
    var lineas = simular(null, 0, 0);
    var antes = lineas.reduce(function (a, l) { return a + l.valor; }, 0);
    var nuevas = items.map(function (it) { return { id: String(it.id), qty: it.cantidad || 1, unidad: it.lista }; });
    var todas = lineas.map(function (l) { return { id: l.id, qty: l.qty, unidad: l.unidad }; }).concat(nuevas);
    var medida = {};
    todas.forEach(function (l) { var f = famDe[l.id]; if (f) medida[f.id] = (medida[f.id] || 0) + (f.tipo === 'monto' ? l.unidad * l.qty : l.qty); });
    var despues = 0, res = [];
    todas.forEach(function (l, i) {
      var f = famDe[l.id], pct = f ? pctPara(f, medida[f.id]) : 0, v = Math.round(l.unidad * l.qty * (1 - pct / 100));
      despues += v;
      if (i >= lineas.length) res.push({ total: v, lista: l.unidad * l.qty, pct: pct });
    });
    return { items: res, total: res.reduce(function (a, r) { return a + r.total; }, 0), lista: res.reduce(function (a, r) { return a + r.lista; }, 0), extra: despues - Math.round(antes) };
  }

  function avisar() {
    oyentes.forEach(function (fn) { try { fn(carrito); } catch (e) {} });
    try { document.dispatchEvent(new CustomEvent('mt-escalera:carrito', { detail: carrito })); } catch (e) {}
  }
  var leyendo = null;
  function actualizar() {
    if (leyendo) return leyendo;
    leyendo = fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { carrito = c; leyendo = null; avisar(); return c; })
      .catch(function () { leyendo = null; });
    return leyendo;
  }
  var espera = null;
  function pronto() { clearTimeout(espera); espera = setTimeout(actualizar, 250); }

  // Cualquier cambio del carrito (tema, Kaching, quiz…) pasa por /cart/*.js: se vuelve a leer después.
  var fetchOriginal = window.fetch;
  window.fetch = function (url) {
    var p = fetchOriginal.apply(this, arguments);
    try {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(pronto, pronto);
    } catch (e) {}
    return p;
  };
  ['cart:refresh', 'kaching-cart:cart-updated', 'kaching-cart:item-added', 'kaching-cart:item-removed'].forEach(function (ev) {
    document.addEventListener(ev, pronto);
  });

  // --- Regalos: cuántas unidades de este producto faltan para cada regalo, con lo que ya hay en el carrito ---
  // Las reglas son las de Kaching Cart (reglas de regalo y barra de premios), leídas del script que Kaching pone en
  // la página. Si no están (tema publicado sin Kaching Cart, o Kaching cambió su formato), devuelve null y el
  // bloque de regalos usa los números fijos de su configuración.
  var kc = null;
  function objetoDesde(texto, desde) {
    var i = texto.indexOf('{', desde), prof = 0, enTexto = false;
    if (i < 0) return null;
    for (var k = i; k < texto.length; k++) {
      var ch = texto[k];
      if (enTexto) { if (ch === '\\') k++; else if (ch === '"') enTexto = false; continue; }
      if (ch === '"') enTexto = true;
      else if (ch === '{') prof++;
      else if (ch === '}' && --prof === 0) { try { return JSON.parse(texto.slice(i, k + 1)); } catch (e) { return null; } }
    }
    return null;
  }
  function configKaching() {
    if (kc !== null) return kc;
    kc = false;
    var scripts = document.querySelectorAll('script:not([src])');
    for (var n = 0; n < scripts.length; n++) {
      var t = scripts[n].textContent || '';
      var i = t.indexOf('autoAtcRules: {');
      if (i < 0) continue;
      var reglas = objetoDesde(t, i);
      var j = t.indexOf('"tieredPromotionsBar":{');
      var barra = j > -1 ? objetoDesde(t, j + 22) : null;
      kc = { reglas: (reglas && reglas.rules || []).filter(function (r) { return r.isEnabled; }), barra: barra && barra.isActive ? barra : null };
      break;
    }
    return kc;
  }
  function idNum(x) { return String(x || '').replace(/\D/g, ''); }
  // El carrito como quedaría al sumar «q» unidades del producto: líneas con su valor ya con la escalera
  // (como lo verá Kaching después del cambio a descuentos automáticos). Sin las líneas de regalo en $0.
  function simular(pid, unidad, q) {
    var lineas = ((carrito && carrito.items) || []).filter(function (it) { return it.final_line_price !== 0; }).map(function (it) {
      return { id: String(it.product_id), qty: it.quantity, unidad: (it.original_price || it.price) / 100 };
    });
    if (q > 0) lineas.push({ id: String(pid), qty: q, unidad: unidad });
    var medida = {};
    lineas.forEach(function (l) { var f = famDe[l.id]; if (f) medida[f.id] = (medida[f.id] || 0) + (f.tipo === 'monto' ? l.unidad * l.qty : l.qty); });
    lineas.forEach(function (l) { var f = famDe[l.id]; l.valor = l.unidad * l.qty * (1 - (f ? pctPara(f, medida[f.id]) : 0) / 100); });
    return lineas;
  }
  // true / false, o null si la regla usa algo que aquí no se sabe evaluar.
  function cumpleRegla(r, lineas) {
    var res = r.triggers.map(function (t) {
      if (t.conditionType !== 'product') return null;
      var ids = (t.values || []).map(function (v) { return idNum(v && v.productId); });
      var de = lineas.filter(function (l) { return ids.indexOf(l.id) > -1; });
      // Kaching exige al menos un producto de la lista: «Any of» (any) y «qty ≥ 0» se cumplen con 1, no con 0.
      if (!de.length) return false;
      if (t.thresholdType === 'any') return true;
      if (t.thresholdType === 'total_quantity') return de.reduce(function (a, l) { return a + l.qty; }, 0) >= t.threshold;
      if (t.thresholdType === 'total_value') return de.reduce(function (a, l) { return a + l.valor; }, 0) >= t.threshold;
      return null;
    });
    if (res.indexOf(null) > -1 || !res.length) return null;
    return r.triggerMatchMode === 'any' ? res.indexOf(true) > -1 : res.indexOf(false) < 0;
  }
  function cumpleTramo(barra, tramo, lineas) {
    var fuera = (barra.excludedProductIds || []).concat(barra.productsExcludedFromUnlockCount || []).map(idNum);
    var de = lineas.filter(function (l) { return fuera.indexOf(l.id) < 0; });
    if (barra.thresholdType === 'cart-total') return de.reduce(function (a, l) { return a + l.valor; }, 0) >= tramo.threshold;
    if (barra.thresholdType === 'item-quantity') return de.reduce(function (a, l) { return a + l.qty; }, 0) >= tramo.threshold;
    return null;
  }
  // regalos: [{ producto: id del producto de regalo, visual: true si es un cuadro como «Envío gratis», nombre }]
  // Devuelve, para cada regalo, la cantidad mínima de este producto que lo entrega (1 si el carrito ya lo da),
  // o null si no hay regla que lo explique. Varios regalos del mismo producto se reparten las reglas en orden.
  function minimosRegalos(pid, unidad, regalos) {
    var c = configKaching();
    if (!c || !carrito) return null;
    var condiciones = {};
    function clave(g) { return g.visual ? 'envio' : idNum(g.producto); }
    c.reglas.forEach(function (r) {
      ((r.action && r.action.items) || []).forEach(function (a) {
        var k = idNum(a.productId); (condiciones[k] = condiciones[k] || []).push(function (l) { return cumpleRegla(r, l); });
      });
    });
    if (c.barra) (c.barra.tiers || []).forEach(function (t) {
      var ks = t.type === 'shipping-discount' ? ['envio'] : (t.targets || []).map(function (x) { return idNum(x.productId); });
      ks.forEach(function (k) { (condiciones[k] = condiciones[k] || []).push(function (l) { return cumpleTramo(c.barra, t, l); }); });
    });
    var usados = {};
    var mins = {};
    Object.keys(condiciones).forEach(function (k) {
      mins[k] = condiciones[k].map(function (cumple) {
        for (var q = 1; q <= 60; q++) { var r = cumple(simular(pid, unidad, q)); if (r === null) return null; if (r) return q; }
        return null;
      }).filter(function (m) { return m !== null; }).sort(function (a, b) { return a - b; });
    });
    return regalos.map(function (g) {
      if (g.visual && !/env[ií]o/i.test(g.nombre || '')) return null;
      var k = clave(g), lista = mins[k] || [];
      var n = usados[k] || 0; usados[k] = n + 1;
      return n < lista.length ? lista[n] : null;
    });
  }

  // Id del producto desde su handle (/products/<handle>.js), guardado en la sesión: el quiz y «Agrégalos a tu
  // carrito» conocen el producto por su enlace, no por su id.
  var ids = {};
  function idDeHandle(handle) {
    if (ids[handle]) return ids[handle];
    try { var g = sessionStorage.getItem('ffe:id:' + handle); if (g) return (ids[handle] = Promise.resolve(g)); } catch (e) {}
    ids[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { var id = d && d.id ? String(d.id) : null; try { if (id) sessionStorage.setItem('ffe:id:' + handle, id); } catch (e) {} return id; })
      .catch(function () { return null; });
    return ids[handle];
  }

  window.MTEscalera = {
    cotizar: cotizar,
    familia: function (id) { return famDe[String(id)] || null; },
    carrito: function () { return carrito; },
    alCambiar: function (fn) { oyentes.push(fn); if (carrito) fn(carrito); },
    actualizar: actualizar,
    plata: plata,
    minimosRegalos: minimosRegalos,
    productoFicha: function () { return productoFicha(); },
    idDeHandle: idDeHandle,
    cotizarVarios: cotizarVarios
  };

  // --- Ficha: escalera de Shrine con lo que ya hay en el carrito ---
  function productoFicha() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (m && m.id) return m.id;
    var i = document.querySelector('form[action*="/cart/add"] input[name="product-id"]');
    return i ? i.value : null;
  }
  var originales = new WeakMap();
  function guardar(el) { if (el && !originales.has(el)) originales.set(el, el.innerHTML); }
  function restaurar(el) { if (el && originales.has(el) && el.innerHTML !== originales.get(el)) el.innerHTML = originales.get(el); }

  function pintarFicha() {
    var qb = document.querySelector('quantity-breaks');
    var pid = productoFicha();
    if (!qb || !pid || !famDe[String(pid)]) return;
    var base = Number(qb.dataset.basePrice || 0) / 100;
    if (!base) return;
    var nota = qb.querySelector('.mte-nota');
    var algunCambio = false;
    qb.querySelectorAll('label.quantity-break').forEach(function (l) {
      var q = Number(l.dataset.quantity || 1);
      var c = cotizar(pid, base, q);
      var precio = l.querySelector('.quantity-break__price');
      var tachado = l.querySelector('.quantity-break__compare-price');
      var beneficio = l.querySelector('.quantity-break__benefit');
      var leyenda = l.querySelector('.quantity-break__caption');
      [precio, tachado, beneficio, leyenda].forEach(guardar);
      // «Tu carrito sube solo $X»: solo si el carrito ya trae de la misma familia y lo que ya estaba baja de escalón
      // (si no, sube lo mismo que el precio de la opción y la línea sobra).
      var sube = l.querySelector('.mte-sube');
      var conSube = c.yaEnCarrito && c.pct > c.pctAntes && c.extra < c.total;
      if (!conSube && sube) sube.remove();
      if (!c.yaEnCarrito) { [precio, tachado, beneficio, leyenda].forEach(restaurar); return; }
      if (conSube) {
        var izq = l.querySelector('.quantity-break__left');
        if (izq && !sube) { sube = document.createElement('span'); sube.className = 'mte-sube'; izq.insertBefore(sube, izq.querySelector('.ffrg-qb')); }
        var ts = 'Tu carrito sube solo ' + plata(c.extra);
        if (sube && sube.textContent !== ts) sube.textContent = ts;
      }
      algunCambio = true;
      if (precio) { var hp = '<strong>' + plata(c.total) + '</strong>'; if (precio.innerHTML !== hp) precio.innerHTML = hp; }
      if (tachado) { var ht = c.pct > 0 ? plata(c.lista) : ''; if (tachado.innerHTML !== ht) tachado.innerHTML = ht; tachado.classList.toggle('hidden', c.pct <= 0); }
      if (beneficio && originales.get(beneficio) && /\d+\s*%/.test(originales.get(beneficio))) {
        var hb = originales.get(beneficio).replace(/\d+(\s*%)/, c.pct + '$1'); if (beneficio.innerHTML !== hb) beneficio.innerHTML = hb;
      }
      if (leyenda && originales.get(leyenda) && /\$\s?[\d.]+/.test(originales.get(leyenda))) {
        // La leyenda es «[price_each] c/u» (igual que FunFungi desde el 17-10): se reescribe con el precio por unidad
        var hl = originales.get(leyenda).replace(/\$\s?[\d.]+/, plata(c.total / q)); if (leyenda.innerHTML !== hl) leyenda.innerHTML = hl;
      }
    });
    if (algunCambio) {
      if (!nota) {
        nota = document.createElement('p');
        nota.className = 'mte-nota';
        nota.style.cssText = 'margin:0 0 8px;font-size:12.5px;line-height:1.35;text-align:center;color:var(--ffp-pag-tono,#2B2622);font-weight:600';
        var titulo = qb.querySelector('.quantity-breaks__title');
        qb.insertBefore(nota, titulo ? titulo.nextSibling : qb.firstChild);
      }
      if (nota.textContent !== 'Precios con lo que ya tienes en tu carrito') nota.textContent = 'Precios con lo que ya tienes en tu carrito';
    } else if (nota) {
      nota.remove();
    }
  }
  // --- Tarjetas (colecciones, destacados, relacionados): precio de agregar 1 con lo que ya hay en el carrito ---
  function pintarTarjetas() {
    document.querySelectorAll('.mt-precio-dinamico[data-mt-producto]').forEach(function (caja) {
      var id = caja.dataset.mtProducto, lista = Number(caja.dataset.mtLista || 0) / 100;
      if (!famDe[String(id)] || !lista) return;
      guardar(caja);
      var c = cotizar(id, lista, 1);
      // Con descuento aunque el carrito esté vacío si el producto solo ya lo alcanza (Pack 4, dúos).
      if (c.pct <= 0) { restaurar(caja); return; }
      var html = '<div class="price price--on-sale mte-precio"><div class="price__container"><div class="price__sale">' +
        '<span class="price-item price-item--sale price-item--last">' + plata(c.total) + '</span> ' +
        '<s class="price-item price-item--regular">' + plata(c.lista) + '</s></div></div></div>' +
        '<p class="mte-tag">' + c.pct + '% OFF' + (c.yaEnCarrito ? ' con tu carrito' : '') + '</p>';
      if (caja.innerHTML !== html) caja.innerHTML = html;
    });
  }
  // Precios sueltos dentro de un texto (botón del final de los artículos, videos comprables): «$15.192 $18.990».
  function pintarSimples() {
    document.querySelectorAll('.mt-precio-simple[data-mt-producto]').forEach(function (el) {
      var id = el.dataset.mtProducto, lista = Number(el.dataset.mtLista || 0) / 100;
      if (!famDe[String(id)] || !lista) return;
      guardar(el);
      var c = cotizar(id, lista, 1);
      if (c.pct <= 0) { restaurar(el); return; }
      var html = plata(c.total) + ' <s class="mte-s">' + plata(c.lista) + '</s>';
      if (el.innerHTML !== html) el.innerHTML = html;
    });
  }
  // % propio de una sugerencia de Kaching Cart (regla por producto del módulo de sugerencias), 0 si no tiene.
  function pctSugerencia(id, lateral) {
    var cs = window.__kachingCartProps && window.__kachingCartProps.cartSettings;
    var m = cs && cs[lateral ? 'sideUpsell' : 'productUpsell'], mejor = 0;
    ((m && m.rules) || []).forEach(function (r) {
      if (r.isEnabled === false) return;
      (r.targets || []).forEach(function (t) {
        if (String(t.productId) === String(id) && t.discount && t.discount.type === 'percentage') mejor = Math.max(mejor, Number(t.discount.amount) || 0);
      });
    });
    return mejor;
  }
  // Sugerencias del carrito de Kaching (abajo y lateral): precio de agregar 1 con lo que ya hay en el carrito.
  // No se toca el precio de Kaching (lo redibuja él): se oculta y al lado va el nuestro. Si la sugerencia trae % propio
  // (17-10: 10 % en packs y kits), su precio final ya lo trae: la lista se saca de ahí, y como en una línea gana el
  // mejor descuento (no se suman), se muestra el nuestro solo si la escalera da más; si no, queda el de Kaching.
  function pintarUpsell() {
    document.querySelectorAll('.kaching-product-upsell-item[data-product-id], .kaching-side-upsell-item[data-product-id]').forEach(function (item) {
      var id = item.dataset.productId;
      var caja = item.querySelector('[class$="__price-container"]');
      var suyo = caja && caja.querySelector('[class$="__price-container-discounted"], [class$="__price-final"]');
      var final = caja && caja.querySelector('[class$="__price-final"]');
      var insignia = caja && caja.querySelector('[class$="__badge"]');
      if (!suyo || !final || !famDe[String(id)]) return;
      var propio = pctSugerencia(id, item.classList.contains('kaching-side-upsell-item'));
      var lista = Math.round(Number((final.textContent || '').replace(/\D/g, '')) / (1 - propio / 100));
      var mio = caja.querySelector('.mte-up');
      var c = lista ? cotizar(id, lista, 1) : null;
      if (!c || c.pct <= propio) {
        if (mio) mio.remove(); if (suyo.style.display) suyo.style.display = ''; if (insignia && insignia.style.display) insignia.style.display = '';
        return;
      }
      if (insignia && insignia.style.display !== 'none') insignia.style.display = 'none';
      var tag = c.yaEnCarrito && c.pct > c.pctAntes && c.extra < c.total
        ? c.pct + '% OFF · tu carrito sube solo ' + plata(c.extra)
        : c.pct + '% OFF' + (c.yaEnCarrito ? ' con tu carrito' : '');
      var html = '<span class="mte-up__precio">' + plata(c.total) + '</span><s class="mte-s">' + plata(c.lista) + '</s><span class="mte-up__tag">' + tag + '</span>';
      if (!mio) { mio = document.createElement('span'); mio.className = 'mte-up'; caja.appendChild(mio); }
      if (mio.innerHTML !== html) mio.innerHTML = html;
      if (suyo.style.display !== 'none') suyo.style.display = 'none';
    });
  }
  if (!document.getElementById('mte-css')) {
    var st = document.createElement('style');
    st.id = 'mte-css';
    st.textContent = '.mte-tag{margin:2px 0 0;font-size:1.15rem;font-weight:700;line-height:1.2;color:var(--ffp-tono, #C55281)}.mte-s{opacity:.65;font-weight:400}' +
      '.mte-up{display:flex;flex-wrap:wrap;align-items:baseline;gap:0 6px}.mte-up__precio{font-weight:700}' +
      '.mte-up__tag{flex-basis:100%;margin-top:1px;font-size:11.5px;font-weight:700;line-height:1.25;color:#C55281}' +
      '.kaching-side-upsell-item .mte-up{justify-content:center;text-align:center;padding:0 8px}' +
      '.mte-sube{display:block;margin-top:2px;font-size:12px;font-weight:700;line-height:1.25;color:var(--ffp-pag-tono,#C55281)}';
    document.head.appendChild(st);
  }

  window.MTEscalera.alCambiar(pintarFicha);
  window.MTEscalera.alCambiar(pintarTarjetas);
  window.MTEscalera.alCambiar(pintarSimples);
  window.MTEscalera.alCambiar(pintarUpsell);
  // Tarjetas que aparecen después (carruseles, filtros, «cargar más»): se repintan solas.
  var esperaTarjetas = null;
  new MutationObserver(function () { clearTimeout(esperaTarjetas); esperaTarjetas = setTimeout(function () { if (carrito) { pintarTarjetas(); pintarSimples(); pintarUpsell(); } }, 200); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', actualizar);
  else actualizar();
})();
